import axios from "axios"

const API_URL = process.env.REACT_APP_API_BASE_URL || "https://clientportal.coldblock.ca/api"

function getCookieValue(name) {
  const cookie = document.cookie
    .split("; ")
    .find(entry => entry.startsWith(`${name}=`))

  if (!cookie) {
    return null
  }

  return decodeURIComponent(cookie.split("=")[1])
}

/** For native `fetch()` state-changing calls (e.g. multipart uploads). Axios adds this via interceptors. */
export function getCsrfHeaders() {
  const xsrfToken = getCookieValue("XSRF-TOKEN")
  return xsrfToken ? { "X-XSRF-TOKEN": xsrfToken } : {}
}

const axiosApi = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
})

axiosApi.interceptors.request.use(config => {
  const method = (config.method || "get").toUpperCase()
  const headers = config.headers || {}

  // Backend requires CSRF header for non-GET requests when session cookie exists.
  if (method !== "GET" && method !== "HEAD" && method !== "OPTIONS") {
    const xsrfToken = getCookieValue("XSRF-TOKEN")

    if (xsrfToken) {
      headers["X-XSRF-TOKEN"] = xsrfToken
    }
  }

  return {
    ...config,
    headers,
    withCredentials: true,
  }
})

axiosApi.interceptors.response.use(
  response => response,
  error => Promise.reject(error)
)

export async function get(url, config = {}) {
  return await axiosApi.get(url, { ...config }).then(response => response.data)
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function patch(url, data, config = {}) {
  return axiosApi
    .patch(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then(response => response.data)
}
